<template>
    <tr v-for="n in rows" :key="`skeleton-${n}`" class="skeleton-row">
        <td v-for="c in columns" :key="`skeleton-con-${c}`">
            <div class="skeleton skeleton-text"></div>
        </td>

    </tr>
</template>

<script setup>
//eslint-disable-next-line
const props = defineProps({
    rows: { type: Number, default: 6 },
    columns: { type: Number, default: 6 }
})
</script>

<style scoped>
/* Skeleton Loading */
.skeleton-row td {
    padding: 1rem;
}

.skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    border-radius: 4px;
}

.skeleton-text {
    height: 12px;
    width: 80%;
}

.skeleton-badge {
    height: 24px;
    width: 60px;
}

@keyframes loading {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.spin {
    animation: spin 1s linear infinite;
}
</style>